import { useLocaleSettings } from './useLocaleSettings';
import { useLocaleStore } from '../store/locale.store';
import { formatTimeOnly } from '../utils/intl-locale';

/**
 * Fechas y horas con la configuración regional de la empresa (`locale.dateFormat`) y el idioma activo,
 * no con el idioma del navegador: así una fecha no cambia de orden (mm/dd o dd/mm) según la computadora.
 */
export function useDateTime() {
  const { formatDate, dateFormat } = useLocaleSettings();
  const locale = useLocaleStore((s) => s.locale);
  const time = (value: Date | string | number) => formatTimeOnly(value, locale, { hour: '2-digit', minute: '2-digit', hour12: false });
  return {
    dateFormat,
    date: (value: Date | string | undefined | null) => formatDate(value),
    time,
    dateTime: (value: Date | string | number) => `${formatDate(new Date(value))} ${time(value)}`,
  };
}
